/**
 * Roles model
 */
export class Roles {
  constructor(
    public value: string,
    public menuDescription?: string,
    public isMenuVisible?: boolean
  ) {}
}
